module.exports = __webpack_public_path__ + "img/dcb2.c0407ba8.png";